import React, { useContext, useState, useRef, useLayoutEffect } from "react";
import "../invoices.scss";
import UserSidebar from "../../../../components/common/user-sidebar";
import AddRefundComponent from "../../../../components/pshb/add-refund";

const ReintegrosSolicitud = () => {

  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <div className="d-flex help-page" ref={ref}>
      <AddRefundComponent> </AddRefundComponent>
    </div>
  );
};

export default ReintegrosSolicitud;
